export default __webpack_public_path__ + "static/media/def_male_pic.a9c615c0.png";